import { NotificationCategory, NotificationName } from 'typings/enums';
import { dateFormatDistanceToNow } from 'common/date-operation';
import { notificationStore } from 'utils/MobxDataManager/singletons';

export class BaseNotificationItem {
    notificationName: NotificationName;
    notificationData: string;
    timeStamp: string
    data: NotificationData;
    category: Nullable<NotificationCategory>;
    createdTimeStamp: string;
    entityId: string;

    constructor(props: IBaseNotificationItem) {
        this.timeStamp = props.timeStamp;
        this.createdTimeStamp = props.createdTimeStamp;
        this.entityId = props.entityId;
        this.data = JSON.parse(props.notificationData);
    }

    get timeStampDateType(): Date {
        return new Date(this.timeStamp);
    }

    get timeStampText(): string {
        return dateFormatDistanceToNow(this.timeStampDateType);
    }

    afterClick(): void {
        notificationStore.toggleNotificationMenu();
    }

    parseNotificationData(): void {
        this.data = JSON.parse(this.notificationData);
    }
}

